module.exports = __webpack_public_path__ + "static/media/paint-focused.37889150.png";